import { MutationKey } from '@tanstack/react-query';

import { CommonSuccess, GenericFailure } from '@playq/services-shared';
import { AppSupportRequest } from '@playq/services-beetle';
import { Environment } from '@playq/octopus-common';

import { useEitherMutation, UseMutationOptionsExtended } from '/api/service-hooks';
import { SupportContentType, IBeetleId, IBeetleStatus } from '/component/Support/BeetlesLookup/types';

import { methods } from './serviceHandlerRequest';

type UpdateStatusProps = { id: IBeetleId; status: IBeetleStatus; env: Environment };
export const updateStatusMutationKey: MutationKey = ['mutation', 'updateStatus'];

export const useUpdateStatus = (
  method: SupportContentType,
  options?: UseMutationOptionsExtended<CommonSuccess | AppSupportRequest, GenericFailure | Error, UpdateStatusProps>
) => {
  const request = methods(method);
  return useEitherMutation(({ id, status, env }) => request.updateStatus(id, status, env), {
    mutationKey: updateStatusMutationKey,
    ...options,
  });
};
